export default __webpack_public_path__ + "media/images/appel_sortant-5ee4d6cfff8a8126120ad0c83cb76459.png";